import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { showSplash } from '../../actions/splash-actions';

// StatsigRouteSwitch's enabled path without the gate: an unconditional hop to
// the new app for pages whose cutover needs no flip ceremony. The query
// string must survive the hop for the same reason as the gated switch
// (OAuth returns and deep links carry their state in params).
const ExternalRedirect = ({ to }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!to) {
            return;
        }
        const { search = '' } = window.location;
        let target = to;
        if (search) {
            target = `${to}${to.includes('?') ? '&' : '?'}${search.slice(1)}`;
        }
        dispatch(showSplash(true));
        // replace, not href: the legacy URL must not stay in history, or the
        // browser back button would land here and immediately bounce forward.
        window.location.replace(target);
    }, [dispatch, to]);

    // Empty fragment, not null: a function that never returns JSX isn't
    // recognized as a React component by Sonar, which then flags the
    // PascalCase name (S100).
    return <></>;
};

ExternalRedirect.propTypes = {
    to: PropTypes.string.isRequired,
};

export default ExternalRedirect;
